import { Fragment } from 'react'
import { useTranslations } from '@/lib/next-shim'

import LinkButton from '@/components/external/material/LinkButton'

type MeetingLinkCardProps = {
  link: string
  name: string
  specialities: Array<{
    code: string
    name: string
  }>
}

export function MeetingLinkCard(props: MeetingLinkCardProps) {
  const { link, name, specialities } = props

  const t = useTranslations()

  return (
    <div className="relative rounded-lg bg-white shadow-sm border border-white hover:border-gray-400">
      <div className="px-4 pt-5 pb-2 sm:px-6">
        <div className="flex flex-wrap items-center justify-between sm:flex-nowrap">
          <h3 className="text-base font-semibold leading-6 text-gray-900">{name}</h3>
          <LinkButton href={link} className="text-xs font-semibold" size="small" variant="outlined">
            {t('button.viewMeetingLink.label')}
          </LinkButton>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-x-2.5 px-4 pb-5 sm:px-6 text-xs leading-5 text-gray-400">
        {specialities.map((speciality, idx) => (
          <Fragment key={speciality.code}>
            <p className="truncate whitespace-nowrap">{speciality.name}</p>
            {idx !== specialities.length - 1 && (
              <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 flex-none fill-gray-300">
                <circle cx={1} cy={1} r={1} />
              </svg>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}
